<style
  lang="postcss"
  scoped
>
  .banner {
    position: relative;
    overflow: hidden;

    & .pagination {
      position: absolute;
      bottom: 0.08rem;
      left: 0;
      width: 100%;
      text-align: center;
      z-index: 99;
      line-height: 1;
    }

    /* 保证分页圆点的可视性（针对 Swiper 6） */
    & :deep(.swiper-pagination-bullet) {
      width: 0.08rem;
      height: 0.08rem;
      margin: 0 0.04rem;
      background: #fff;
      opacity: 0.5;
      border-radius: 50%;
      display: inline-block;
    }

    & :deep(.swiper-pagination-bullet-active) {
      opacity: 1;
      background: var(--base-color, #fff);
    }

    & img {
      width: 100%;
      display: block;
      height: auto;
    }
  }
</style>
<template>
  <swiper
    v-if="list && list.length"
    class="banner"
    :options="swiperOption"
    :style="formatStyle(userStyle.box)"
    data-style-name="box"
  >
    <swiper-slide
      v-for="(val) in list"
      :key="val.id"
    >
      <my-link
        :link="val.link || {}"
        style="width: 100%"
        :data-umami-event="val['event-name']"
      >
        <img
          :src="imgSize(val.banner)"
          data-style-name="banner"
          :style="formatStyle(userStyle.banner)"
        />
      </my-link>
    </swiper-slide>
    <!-- Vue-Awesome-Swiper 需要明确 slot 用于放置分页 -->
    <div
      class="pagination"
      slot="pagination"
    ></div>
  </swiper>
  <my-module-preview
    :code="$attrs.code"
    v-else
  />
</template>
<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import SwiperCore, { Autoplay, Pagination } from 'swiper'
  import 'swiper/swiper-bundle.min.css'
  import MyLink from './Link'
  import MyModulePreview from '@/components/MyModulePreview'

  // 在 Swiper 6 中必须显式安装插件
  SwiperCore.use([Autoplay, Pagination])

  export default {
    name: 'MySwiper',
    components: {
      MyModulePreview,
      Swiper,
      SwiperSlide,
      MyLink
    },
    props: {
      list: {
        type: Array
      },
      userStyle: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data () {
      return {
        swiperOption: {
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.pagination',
            clickable: true
          },
          // 强制 Swiper 重新初始化(防止动态列表导致的计算错误)
          observeParents: true,
          observer: true
        }
      }
    }
  }
</script>
